export default "__VITE_ASSET__Dpfsv9_P__"